import { useSelector } from 'react-redux';

const SuperAdmin = () => {
  const user = useSelector(({ user }) => user.user);
  return (
    <>
      <h1>SuperAdmin</h1>
      <p>{user && user.first_name}</p>
    </>
  );
};

export default SuperAdmin;
